<script>
// Collapsible quick search: shows only a search icon; on click the input field
// appears (mirrors the talk navbar). Keeps the navbars from overflowing on
// mobile now that they carry extra tool buttons.
export default {
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {
      search: this.value,
      searchActive: !!this.value,
    }
  },
  methods: {
    onInput() {
      if (this.search === '') this.$emit('delete-search')
    },
    activate() {
      this.searchActive = true
      this.$nextTick(() => { if (this.$refs.input) this.$refs.input.focus() })
    },
    deactivate() {
      this.searchActive = false
      this.search = ''
      this.$emit('delete-search')
    },
    submit() {
      this.$emit('search', this.search)
    },
  },
}
</script>

<template>
  <div class="c-search-wrap" :class="{ 'c-search-wrap--active': searchActive }">
    <form class="form-inline" @submit.prevent="submit">
      <div class="d-flex flex-nowrap align-items-center gap-1">
        <input v-if="searchActive" ref="input" class="c-search-input form-control form-control-sm"
               type="search" placeholder="Suche" v-model="search"
               @input="onInput" @keyup.enter="submit">
        <button v-if="searchActive" type="button" class="btn btn-sm btn-secondary" @click.prevent="submit">
          <span class="fa fa-search"></span>
        </button>
        <button v-if="searchActive" type="button" class="btn btn-sm" @click.prevent="deactivate">
          <span class="fa fa-times"></span>
        </button>
        <button v-else type="button" class="btn btn-sm btn-secondary mb-1" title="Suche" @click.prevent="activate">
          <span class="fa fa-search"></span>
        </button>
      </div>
    </form>
  </div>
</template>

<style scoped>
.c-search-input {
  font-size: 1rem;
  padding: 0.2rem 0.4rem;
  width: 100%;
}
.c-search-wrap {
  flex-shrink: 0;
}
.c-search-wrap--active {
  flex-grow: 1;
}
</style>
